(function () {
	'use strict';

	angular.module('mx.components').component('mxTimelineLazy', {
		bindings: {
			items: '<',
			selectedItem: '=?',
			idFieldName: '@',
			titleFieldName: '@',
			dateFieldName: '@',
			contentFieldName: '@',
			maxHeight: '<',
			minHeight: '<',
		},
		controller: MxTimelineLazyCtrl,
		controllerAs: 'vm',
		template:
			'<div oc-lazy-load="ngVis"><mx-timeline items="vm.items" selected-item="vm.selectedItem" id-field-name="{{::vm.idFieldName}}" title-field-name="{{::vm.titleFieldName}}" date-field-name="{{::vm.dateFieldName}}" content-field-name="{{::vm.contentFieldName}}" max-height="::vm.maxHeight" min-height="::vm.minHeight"></mx-timeline></div>',
	});

	MxTimelineLazyCtrl.$inject = ['$ocLazyLoad', 'mx.components.LazyLoadCfg', 'mx.shell.Config'];

	function MxTimelineLazyCtrl($ocLazyLoad, lazyLoadCfg, mxConfig) {
		var vm = this;

		const anticache = `?anticache=${mxConfig.settings.productVersion}`;

		$ocLazyLoad.setModuleConfig({
			name: 'ngVis',
			serie: true,
			files: [
				`${lazyLoadCfg.componentsDir}vis/dist/vis.min.css${anticache}`,
				`${lazyLoadCfg.componentsDir}vis/dist/vis.min.js${anticache}`,
				`${lazyLoadCfg.componentsDir}angular-visjs/angular-vis.js${anticache}`,
			],
		});

		vm.$onInit = function () {};
		return vm;
	}
})();
